import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Highlights from "./components/Highlights";
import About from "./components/About";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";
import ResumePage from "./components/Resume";
import ScrollVideo from "./components/ScrollVideo"
import {BrowserRouter as Router,Route,Routes} from "react-router-dom"

import * as Sentry from "@sentry/react";
import Experience from "./components/Experience";


const App = () => {
  return (
    <Router>
    <main className="bg-black">
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
          <Hero />
          
          <About></About>
          <Highlights />
          <Features />
          <HowItWorks />
          <Experience></Experience>
         
          <Footer />
          </>
        }></Route>
        <Route path="/resume" element={<ResumePage></ResumePage>}></Route>
        <Route path="/reel" element={<ScrollVideo></ScrollVideo>}></Route>
      </Routes>
    </main>
    </Router>
  );
};

export default Sentry.withProfiler(App);
